import { render, staticRenderFns } from "./TabMisc.vue?vue&type=template&id=5a244ad4"
import script from "./TabMisc.vue?vue&type=script&lang=ts"
export * from "./TabMisc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports